import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './components/calendar/calendar.component';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { FormsModule } from '@angular/forms';
import { MonthComponent } from './components/month/month.component';
import { WeekComponent } from './components/week/week.component';
import { RouterModule } from '@angular/router';
import { CalendarDataCarrierService } from './services/calendar-datacarrier-service/calendar-data-carrier.service';
import { ScheduleOptionsCacheService } from './services/schedule-options-cache-service/schedule-options-cache.service';
import { MobileCalendarComponent } from './components/mobile-calendar/mobile-calendar.component';
import { ClickOutsideModule } from '../../directives/clickOutside';
import { MobileMonthComponent } from './components/mobile-month/mobile-month.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { CalendarCellComponent } from './components/calendar-cell/calendar-cell.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ClickOutsideModule,
    SwiperModule
  ],
  declarations: [
    CalendarComponent,
    ScheduleComponent,
    MonthComponent,
    WeekComponent,
    MobileCalendarComponent,
    MobileMonthComponent,
    CalendarCellComponent],
  providers: [CalendarDataCarrierService,
    ScheduleOptionsCacheService],
  exports: []
})
export class CalendarModule { }
